import type { Question } from '../../types';

export const fraudEnablerOptions = [
  'AI (artificial intelligence)',
  'Bribery',
  'Coercion',
  'Collusion',
  'Conflict of interest',
  'False identity',
  'Phishing, vishing and SMShing',
  'Social Media',
];

const fraudEnablerDetails =
  '<b>AI (artificial intelligence):</b> using artificial intelligence to create or present false information' +
  '<br><b>Bribery:</b> something given or promised to influence behaviour' +
  '<br><b>Coercion:</b> forced agreement or cooperation (for example, due to physical threats)' +
  '<br><b>Collusion:</b> deceptive agreement or cooperation (for example, due to lies or manipulation)' +
  '<br><b>Conflict of interest:</b> not sharing relationships which resulted in personal gain' +
  '<br><b>False identity:</b> using false documents as person or company (for example, a passport or birth certificate)' +
  '<br><b>Phishing, vishing and SMShing:</b> use cyber vulnerabilities using digital communication methods (for example, clicking a malicious link)' +
  '<br><b>Social Media:</b> using this to present disinformation (for example, falsifying personal details)';

export const createFraudEnablerQuestions = (name: string): Question[] =>
  (
    [
      [undefined, name, false],
      ['If multiple', `${name}_additional`, false],
    ] as const
  ).map(([hint, questionName, required]) => ({
    questionType: 'select',
    title: 'What was the fraud enabler?',
    hint,
    hideOptionalLabel: true,
    name: questionName,
    hintOption: 'Please select',
    excludeOptionsFrom:
      hint === 'If multiple'
        ? [
            {
              field: name,
              message: 'Select a different fraud enabler from the first selection.',
            },
          ]
        : undefined,
    detailsHeading: 'Help with fraud enablers',
    detailsContent: fraudEnablerDetails,
    options: fraudEnablerOptions,
    rules: { required },
  }));
